import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrajectories = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 0C16.5 0 15.2 1.1 15 2.6C8 4.3 2.3 9.6 0.6 16.3C0.5 16.8 0.8 17.4 1.3 17.5C1.4 17.5 1.5 17.5 1.6 17.5C2 17.5 2.4 17.2 2.6 16.8C4.2 10.8 9.2 6.1 15.5 4.6C16 5.4 16.9 6 18 6C19.7 6 21 4.7 21 3C21 1.3 19.7 0 18 0ZM18 4C17.4 4 17 3.6 17 3C17 2.4 17.4 2 18 2C18.6 2 19 2.4 19 3C19 3.6 18.6 4 18 4ZM1 19C0.4 19 0 19.4 0 20C0 20.6 0.4 21 1 21C1.6 21 2 20.6 2 20C2 19.4 1.6 19 1 19Z",
		fill: "white"
	})
});
export default SvgTrajectories;
